import Vue from 'vue'
import App from './App.vue'
import VueSocketIO from 'vue-socket.io-extended'
import io from 'socket.io-client'

Vue.config.productionTip = false

const socket = io(process.env.VUE_APP_INVOICE_HELPER_WS, {
	autoConnect: false,
});

Vue.use(VueSocketIO, socket);

new Vue({
  render: h => h(App),
}).$mount('#app')
